/** Redondeo estable a centavos (ARS / montos con 2 decimales). */
export const roundMoneyAmount = (value: number): number =>
  Math.round((value + Number.EPSILON) * 100) / 100;

/**
 * Normaliza montos de instrumentos y el total derivado de su suma.
 * Evita que `toFixed` en el wire format desalinee `totalAmount` vs `amount` por tarjeta.
 */
export const normalizePaymentAmounts = (
  amounts: number[],
): { amounts: number[]; totalAmount: number } => {
  const normalized = amounts.map((amount) => roundMoneyAmount(amount));
  const totalAmount = roundMoneyAmount(normalized.reduce((sum, amount) => sum + amount, 0));
  return { amounts: normalized, totalAmount };
};
